import { ReactElement } from 'react';
import { Typography } from '@mui/material';

import { Copy } from 'modules/common/components/Copy/Copy';
import { cropString } from 'modules/common/utils/cropString';

import { useStyles } from './useStyles';

interface ITokenDetailsProps {
  address: string;
  title: string;
  icon: string;
}

export function TokenDetails({
  address,
  title,
  icon,
}: ITokenDetailsProps): ReactElement {
  const { classes } = useStyles();

  return (
    <div className={classes.root}>
      <img alt="" className={classes.icon} src={icon} />

      <div className={classes.info}>
        <Typography
          color={theme => theme.palette.text.primary}
          fontSize={15}
          fontWeight={600}
        >
          {title}
        </Typography>

        <div className={classes.address}>
          <Typography
            component="div"
            sx={{ display: { xs: 'none', md: 'inline' } }}
            variant="body1"
          >
            {cropString(address, 10)}
          </Typography>

          <Typography
            component="div"
            sx={{ display: { xs: 'inline', md: 'none' } }}
            variant="body1"
          >
            {cropString(address)}
          </Typography>

          <Copy text={address} />
        </div>
      </div>
    </div>
  );
}
